module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Transport Entry Form - " + _vm._s(_vm.formData.enqNumber))])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('b-row', {
    staticClass: " mb-3"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('label', {
    staticClass: "mt-2 mr-3",
    attrs: {
      "for": "jobType"
    }
  }, [_vm._v("Job Type *")]), _vm._v(" "), _c('b-row', _vm._l((_vm.showSegmentArray), function(segmentNameArray, index) {
    return _c('b-col', {
      key: index,
      staticClass: "flex",
      attrs: {
        "cols": segmentNameArray.flex,
        "cols": "12"
      }
    }, [_c('b-form-checkbox', {
      staticClass: "mr-2",
      attrs: {
        "value": segmentNameArray.value,
        "name": 'jobType' + (index + 1),
        "id": 'jobType' + (index + 1)
      },
      on: {
        "change": function($event) {
          _vm.jobTypeSelect(segmentNameArray.value, index)
        }
      },
      model: {
        value: (_vm.formData.jobType[index]),
        callback: function($$v) {
          _vm.$set(_vm.formData.jobType, index, $$v)
        },
        expression: "formData.jobType[index]"
      }
    }, [_c('b-badge', {
      attrs: {
        "variant": "light"
      }
    }, [_vm._v(_vm._s(segmentNameArray.show))])], 1), _vm._v(" "), (!_vm.formData.jobType[index]) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(_vm.errorValidation.jobType))]) : _vm._e()], 1)
  }))], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "enqNumber"
    }
  }, [_vm._v("Client Type:*")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": true,
      "list": _vm.clientTypeList,
      "id": "clientNamenew",
      "option-value": "val",
      "option-text": "type",
      "placeholder": "Client Type"
    },
    on: {
      "input": _vm.fetchType
    },
    model: {
      value: (_vm.formData.clientType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "clientType", $$v)
      },
      expression: "formData.clientType"
    }
  }), _vm._v(" "), (!_vm.formData.clientType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorValidation.clientType))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "enqNumber"
    }
  }, [_vm._v("Shipping Type:*")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": true,
      "list": _vm.shipmentTypeList,
      "option-value": "shipmentTypeVal",
      "option-text": "shipmentTypeText",
      "placeholder": "Select Shipment Type"
    },
    on: {
      "input": _vm.getDataLocations
    },
    model: {
      value: (_vm.formData.shipmentType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "shipmentType", $$v)
      },
      expression: "formData.shipmentType"
    }
  }), _vm._v(" "), (!_vm.formData.shipmentType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorValidation.shipmentType))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "enqNumber"
    }
  }, [_vm._v("Transport Type:*")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": true,
      "list": _vm.transportTypeList,
      "option-value": "transportTypeVal",
      "option-text": "transportTypeText",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.formData.transportType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "transportType", $$v)
      },
      expression: "formData.transportType"
    }
  }), _vm._v(" "), (!_vm.formData.transportType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorValidation.transportType))]) : _vm._e()], 1), _vm._v(" "), (_vm.formData.mainEnquiryId) ? _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "enqNumber"
    }
  }, [_vm._v("ENQ Number:*")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "enqNumber",
      "name": "enqNumber"
    },
    model: {
      value: (_vm.formData.enqNumber),
      callback: function($$v) {
        _vm.$set(_vm.formData, "enqNumber", $$v)
      },
      expression: "formData.enqNumber"
    }
  }), _vm._v(" "), (!_vm.formData.enqNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorValidation.enqNumber))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.formData.clientType == '2') ? _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "lead_comp_name"
    }
  }, [_vm._v("Lead Name:*")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllLeadCompList'],
      "id": "newClientName",
      "option-value": "lead_comp_name",
      "option-text": "lead_comp_name",
      "placeholder": "Select Lead Name"
    },
    on: {
      "input": function($event) {
        _vm.LeadClientDetails()
      }
    },
    model: {
      value: (_vm.formData.newClientName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "newClientName", $$v)
      },
      expression: "formData.newClientName"
    }
  }), _vm._v(" "), (!_vm.formData.newClientName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorValidation.newClientName))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.formData.clientType == '2') ? _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "newClientEmail"
    }
  }, [_vm._v("Client Email:*")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "newClientEmail",
      "name": "newClientEmail"
    },
    model: {
      value: (_vm.formData.newClientEmail),
      callback: function($$v) {
        _vm.$set(_vm.formData, "newClientEmail", $$v)
      },
      expression: "formData.newClientEmail"
    }
  }), _vm._v(" "), (!_vm.formData.newClientEmail) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorValidation.newClientEmail))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.formData.clientType == '2') ? _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "newClientPhoneNumber"
    }
  }, [_vm._v("Contact No. *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "newClientPhoneNumber",
      "name": "newClientPhoneNumber",
      "type": "text"
    },
    model: {
      value: (_vm.formData.newClientPhoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.formData, "newClientPhoneNumber", $$v)
      },
      expression: "formData.newClientPhoneNumber"
    }
  }), _vm._v(" "), (!_vm.formData.newClientPhoneNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorValidation.newClientPhoneNumber))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.formData.clientType == '2') ? _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "newClientAddress"
    }
  }, [_vm._v("Client Address *")]), _vm._v(" "), _c('b-textarea', {
    attrs: {
      "id": "newClientAddress",
      "name": "newClientAddress",
      "type": "number"
    },
    model: {
      value: (_vm.formData.newClientAddress),
      callback: function($$v) {
        _vm.$set(_vm.formData, "newClientAddress", $$v)
      },
      expression: "formData.newClientAddress"
    }
  }), _vm._v(" "), (!_vm.formData.newClientAddress) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorValidation.newClientAddress))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.formData.clientType != '2') ? _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Client:*")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.formData.shipmentType == '' ||
        _vm.formData.transportType == '',
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientfilter",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    on: {
      "input": _vm.getClientFactoryLoc
    },
    model: {
      value: (_vm.formData.clientId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "clientId", $$v)
      },
      expression: "formData.clientId"
    }
  }), _vm._v(" "), (!_vm.formData.clientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorValidation.clientId))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.formData.clientId && !_vm.formData.mainEnquiryId) ? _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "newClientAddress"
    }
  }, [_vm._v("Client Email & State:*")]), _vm._v(" "), _c('b-textarea', {
    attrs: {
      "id": "newClientAddress",
      "name": "newClientAddress",
      "type": "text"
    },
    model: {
      value: (_vm.clientIntro),
      callback: function($$v) {
        _vm.clientIntro = $$v
      },
      expression: "clientIntro"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "from_loc"
    }
  }, [_vm._v("From:*")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": !_vm.formData.clientId,
      "list": _vm.$store.getters['commonDropdownMaster/getAllStuffingList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select From Location"
    },
    model: {
      value: (_vm.formData.from_loc),
      callback: function($$v) {
        _vm.$set(_vm.formData, "from_loc", $$v)
      },
      expression: "formData.from_loc"
    }
  }), _vm._v(" "), (!_vm.formData.from_loc) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorValidation.from_loc))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "to_loc"
    }
  }, [_vm._v("To:*")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": !_vm.formData.clientId,
      "list": _vm.$store.getters['commonDropdownMaster/getAllStuffingList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select To Location"
    },
    model: {
      value: (_vm.formData.to_loc),
      callback: function($$v) {
        _vm.$set(_vm.formData, "to_loc", $$v)
      },
      expression: "formData.to_loc"
    }
  }), _vm._v(" "), (!_vm.formData.to_loc) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorValidation.to_loc))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "commodityType"
    }
  }, [_vm._v("Container Type *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": (_vm.formData.shipmentType == '1' &&
          _vm.formData.multipleContainerType[0] == 'LCL Container') ?
        true :
        false,
      "list": _vm.$store.getters['common/getAllContainerTypeList'],
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Container Type"
    },
    model: {
      value: (_vm.AutoContainerType),
      callback: function($$v) {
        _vm.AutoContainerType = $$v
      },
      expression: "AutoContainerType"
    }
  }), _vm._v(" "), (_vm.formData.multipleContainerType.length > 0) ? _c('span', {
    attrs: {
      "md-flex": "70",
      "md-flex-small": "100"
    }
  }, _vm._l((_vm.formData.multipleContainerType), function(type, index) {
    return _c('md-chip', {
      key: index,
      staticStyle: {
        "margin-top": "38px"
      },
      attrs: {
        "md-deletable": ""
      },
      on: {
        "delete": function($event) {
          _vm.deleteContainer(type)
        }
      }
    }, [_vm._v(_vm._s(type))])
  })) : _vm._e(), _vm._v(" "), (_vm.formData.multipleContainerType.length <= 0) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorValidation.multipleContainerType))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "commodityType"
    }
  }, [_vm._v("Commodity Type:*")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.commodityTypeName,
      "option-value": "commodityTypeVal",
      "option-text": "commodityTypeText",
      "placeholder": "Select Commodity Type"
    },
    model: {
      value: (_vm.formData.commodityType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "commodityType", $$v)
      },
      expression: "formData.commodityType"
    }
  }), _vm._v(" "), (!_vm.formData.commodityType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorValidation.commodityType))]) : _vm._e()], 1), _vm._v(" "), (_vm.formData.commodityType == 'Hazardous') ? _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "IMDGClass"
    }
  }, [_vm._v("IMDG Class")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "IMDGClass",
      "name": "IMDGClass"
    },
    model: {
      value: (_vm.formData.IMDGClass),
      callback: function($$v) {
        _vm.$set(_vm.formData, "IMDGClass", $$v)
      },
      expression: "formData.IMDGClass"
    }
  }), _vm._v(" "), (!_vm.formData.IMDGClass) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorValidation.IMDGClass))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.formData.commodityType == 'Hazardous') ? _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "UNNumber"
    }
  }, [_vm._v("UN Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "UNNumber",
      "name": "UNNumber"
    },
    model: {
      value: (_vm.formData.UNNumber),
      callback: function($$v) {
        _vm.$set(_vm.formData, "UNNumber", $$v)
      },
      expression: "formData.UNNumber"
    }
  }), _vm._v(" "), (!_vm.formData.UNNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorValidation.UNNumber))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.formData.commodityType == 'Hazardous') ? _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "packingCode"
    }
  }, [_vm._v("Packing Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "packingCode",
      "name": "packingCode"
    },
    model: {
      value: (_vm.formData.packingCode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "packingCode", $$v)
      },
      expression: "formData.packingCode"
    }
  }), _vm._v(" "), (!_vm.formData.packingCode) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorValidation.packingCode))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.formData.commodityType == 'Reefer') ? _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('label', [_vm._v("Temperature Req(Degree Celsius)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "temperatureRequired",
      "name": "temperatureRequired"
    },
    model: {
      value: (_vm.formData.temperatureRequired),
      callback: function($$v) {
        _vm.$set(_vm.formData, "temperatureRequired", $$v)
      },
      expression: "formData.temperatureRequired"
    }
  }), _vm._v(" "), (!_vm.formData.temperatureRequired) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorValidation.temperatureRequired))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.formData.commodityType == 'Others') ? _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('label', [_vm._v("Specific Detail if any..!")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "otherComodity",
      "name": "otherComodity"
    },
    model: {
      value: (_vm.formData.otherComodity),
      callback: function($$v) {
        _vm.$set(_vm.formData, "otherComodity", $$v)
      },
      expression: "formData.otherComodity"
    }
  }), _vm._v(" "), (!_vm.formData.otherComodity) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorValidation.otherComodity))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "tptType"
    }
  }, [_vm._v("TPT Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.cctypeList,
      "option-value": "ccTypeVal",
      "option-text": "ccTypeTxt",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.formData.tptType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tptType", $$v)
      },
      expression: "formData.tptType"
    }
  }), _vm._v(" "), (!_vm.formData.tptType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorValidation.tptType))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('label', [_vm._v("ON ACCOUNT OF")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "onAccountOf",
      "name": "onAccountOf"
    },
    model: {
      value: (_vm.formData.onAccountOf),
      callback: function($$v) {
        _vm.$set(_vm.formData, "onAccountOf", $$v)
      },
      expression: "formData.onAccountOf"
    }
  }), _vm._v(" "), (!_vm.formData.onAccountOf) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorValidation.onAccountOf))]) : _vm._e()], 1), _vm._v(" "), (_vm.allModuleIdNew == '' || _vm.allModuleIdNew == null) ? _c('b-col', {
    staticClass: "justify-content-center mt-3",
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.onCloseSubmit
    }
  }, [_vm._v("Save & Submit")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop22",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAddFF
    }
  }), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": _vm.vertical + ' ' + _vm.horizontal,
      "md-duration": _vm.duration
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.snackbarData))])]), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "dialog5",
    attrs: {
      "md-title": _vm.confirm.title,
      "md-content-html": _vm.confirm.contentHtml,
      "md-ok-text": _vm.confirm.ok,
      "md-cancel-text": _vm.confirm.cancel
    },
    on: {
      "close": _vm.onCloseSubmit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4acb8d2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/transportEnq.vue
// module id = 2823
// module chunks = 0